<template>
    <div
        class="portrait-card group relative cursor-pointer overflow-hidden rounded-[28px] border border-app bg-card shadow-xl transition-all duration-300 hover:-translate-y-1.5 hover:border-brand-500/60 hover:shadow-brand-500/20">
        <div class="aspect-[4/5] w-full overflow-hidden bg-brand-500/10">
            <img v-if="speaker.photoUrl" :src="speaker.photoUrl" :alt="speaker.name"
                class="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]" />
            <div v-else class="flex h-full w-full items-center justify-center text-4xl font-black text-brand-500">
                {{ initials(speaker.name) }}
            </div>
        </div>

        <!-- Top gradient + meta -->
        <div class="pointer-events-none absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/55 to-transparent"></div>
        <div class="absolute inset-x-0 top-0 flex items-start justify-between gap-2 p-4">
            <span class="text-[10px] font-black uppercase tracking-[0.18em] text-white/90 drop-shadow">
                Session Speaker
            </span>
            <span v-if="countryFlag(speaker.country)" class="text-lg leading-none drop-shadow" :title="speaker.country">
                {{ countryFlag(speaker.country) }}
            </span>
        </div>

        <!-- Bottom gradient + details -->
        <div class="absolute inset-x-0 bottom-0 flex flex-col gap-1 p-5 pt-16
            bg-gradient-to-t from-black via-black/75 to-transparent">
            <h3 class="text-lg font-extrabold leading-tight text-white">{{ speaker.name }}</h3>
            <p v-if="speaker.role || speaker.company" class="text-xs font-medium leading-snug text-white/70 line-clamp-2">
                {{ [speaker.role, speaker.company].filter(Boolean).join(' · ') }}
            </p>
            <div
                class="grid grid-rows-[0fr] opacity-0 transition-all duration-300 ease-out
                group-hover:grid-rows-[1fr] group-hover:opacity-100 group-focus-within:grid-rows-[1fr] group-focus-within:opacity-100">
                <div class="min-h-0 overflow-hidden">
                    <span
                        class="mt-3 flex items-center justify-center gap-2 rounded-xl border border-brand-400/60
                        bg-brand-500/15 px-4 py-2.5 text-[11px] font-bold uppercase tracking-widest text-brand-200 backdrop-blur-sm">
                        <User class="h-3.5 w-3.5" />
                        View full bio
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { User } from 'lucide-vue-next';
import { EventSpeaker } from '~/types';
import { countryFlag, initials } from '../helpers';

defineProps<{ speaker: EventSpeaker }>();
</script>

<style scoped>
.bg-card {
    background-color: rgb(var(--core-card-bg));
}

.border-app {
    border-color: rgb(var(--core-app-border));
}
</style>
